<template>
    <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
            <v-card-title class="font-weight-bold">
                Agregar Imágenes al Reporte
            </v-card-title>
            
            <v-card-text>
                <v-container>
                    <!-- File Input -->
                    <v-file-input
                        v-model="tempFiles"
                        accept="image/*"
                        label="Seleccionar Imágenes"
                        multiple
                        outlined
                        dense
                        show-size
                        @change="onFilesSelected"
                    ></v-file-input>
                    
                    <!-- Preview Images -->
                    <div v-if="previews.length > 0" class="mt-4">
                        <h4>Vista Previa:</h4>
                        <v-row>
                            <v-col v-for="(preview, idx) in previews" :key="idx" cols="6">
                                <v-card>
                                    <v-img :src="preview" max-height="150" contain></v-img>
                                    <v-card-text class="pb-0">
                                        <v-textarea
                                            v-model="descriptions[idx]"
                                            label="Descripción de la imagen"
                                            outlined
                                            dense
                                            rows="2"
                                            auto-grow
                                        ></v-textarea>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            icon 
                                            small 
                                            @click="removeFile(idx)"
                                            color="red"
                                        >
                                            <v-icon small>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="closeDialog">
                    Cancelar
                </v-btn>
                <v-btn 
                    color="primary" 
                    @click="saveImages"
                    :loading="saving"
                    :disabled="tempFiles.length === 0"
                >
                    {{ isNewReport ? 'Aceptar' : 'Guardar Imágenes' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddClinicalImages',
    props: {
        visible: Boolean,
        reportId: [String, Number],
        isNewReport: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false,
            tempFiles: [],
            previews: [],
            descriptions: [],
            saving: false
        }
    },
    watch: {
        visible(newVal) {
            this.dialog = newVal;
        },
        dialog(newVal) {
            if (!newVal) {
                this.resetForm();
            }
        }
    },
    methods: {
        onFilesSelected() {
            this.previews = [];
            this.descriptions = [];
            
            if (!this.tempFiles || this.tempFiles.length === 0) return;
            
            this.tempFiles.forEach((file, idx) => {
                // Validate file
                if (file.type.startsWith('image/')) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.$set(this.previews, idx, e.target.result);
                    };
                    reader.readAsDataURL(file);
                    this.$set(this.descriptions, idx, '');
                }
            });
        },
        removeFile(idx) {
            this.tempFiles.splice(idx, 1);
            this.previews.splice(idx, 1);
            this.descriptions.splice(idx, 1);
        },
        async saveImages() {
            if (this.tempFiles.length === 0) return;
            
            this.saving = true;
            try {
                // Emit event with files
                this.$emit('imagesSelected', {
                    files: this.tempFiles,
                    previews: this.previews,
                    descriptions: this.descriptions
                });
                
                this.resetForm();
                this.dialog = false;
                this.$emit('close');
            } catch (error) {
                console.error('Error saving images:', error);
            } finally {
                this.saving = false;
            }
        },
        closeDialog() {
            this.dialog = false;
            this.resetForm();
            this.$emit('close');
        },
        resetForm() {
            this.tempFiles = [];
            this.previews = [];
            this.descriptions = [];
        }
    }
}
</script>

<style scoped>
.v-card {
    border-radius: 8px;
}

.v-card-title {
    background-color: #f5f5f5;
}

h4 {
    margin-top: 0;
    color: #333;
}
</style>
